function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicrophoneEmptySlash = function SvgMicrophoneEmptySlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.968 10.408v3.368c0 2.453 1.553 4.513 3.654 5.093a1.46 1.46 0 0 0-.01.163v2.52c-3.447-.626-6.073-3.87-6.073-7.776 0-.726-.544-1.315-1.215-1.315-.67 0-1.215.589-1.215 1.315 0 5.361 3.71 9.785 8.503 10.432v1.396c0 .726.544 1.314 1.215 1.314s1.215-.588 1.215-1.314v-1.396c1.767-.238 3.387-.99 4.728-2.113l4.096 4.432a1.17 1.17 0 0 0 1.747 0 1.414 1.414 0 0 0 0-1.89l-4.097-4.431.014-.02-1.737-1.879c-.005.007-.01.013-.013.02l-1.756-1.9.011-.021-1.849-2-.006.026-4.782-5.174v-.033l-2.43-2.629v.034l-5.18-5.605a1.17 1.17 0 0 0-1.746 0 1.415 1.415 0 0 0 0 1.889Zm2.43 2.628v.74c0 1.451 1.087 2.628 2.43 2.628.209 0 .412-.029.606-.083zm4.88 5.28a4.63 4.63 0 0 1-1.245.553c.006.054.009.108.009.163v2.52c1.1-.2 2.117-.666 2.992-1.336zm2.408-4.984-2.43-2.628V5.89c0-1.452-1.087-2.628-2.429-2.628-1.212 0-2.217.96-2.4 2.217l-1.894-2.05c.816-1.663 2.433-2.796 4.294-2.796 2.684 0 4.859 2.354 4.859 5.257zm2.206 2.387 1.918 2.075c.474-1.238.735-2.595.735-4.018 0-.726-.544-1.315-1.215-1.315-.67 0-1.215.589-1.215 1.315 0 .67-.077 1.322-.223 1.943z",
    style: {
      strokeWidth: 1.37836
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "10.6667px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      InkscapeFontSpecification: "'sans-serif, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      fillOpacity: 1,
      stroke: "none"
    },
    x: 7.917,
    y: 39.58
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 7.917,
    y: 39.58,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "10.6667px",
      fontFamily: "sans-serif",
      InkscapeFontSpecification: "'sans-serif Bold'"
    }
  }, "MIC")));
};
export default SvgMicrophoneEmptySlash;